import React from 'react';
import { Button, Modal, Tag, Typography, theme } from 'antd';
import { useLocation } from 'react-router-dom';
import { useAyuda } from './AyudaProvider';
import { BASE_CONTENIDO } from './contenido';
import { urlContenido } from './catalogo';
import { novedadesPendientes, pantallaDeRuta } from './novedades';

const { Title, Paragraph, Text } = Typography;

// Panel emergente de novedades: solo para las publicaciones marcadas `destacada`, la primera vez que se entra al
// inicio del admin o a Presupuestos. Lo demás vive en el feed del inicio y en el historial, sin interrumpir. Cerrarlo
// —o abrir el tutorial— las marca como leídas. Lee el estado compartido de `AyudaProvider`.
export default function PanelNovedades({ base = BASE_CONTENIDO }) {
  const { token } = theme.useToken();
  const { pathname } = useLocation();
  const { abrir, novedades } = useAyuda();
  const pendientes = novedadesPendientes({
    publicaciones: novedades.publicaciones,
    pantalla: pantallaDeRuta(pathname),
    hoy: novedades.hoy,
    vistas: novedades.vistas,
  });

  if (pendientes.length === 0) return null;

  const cerrar = () => novedades.marcarLeidas(pendientes.map((p) => p.id));
  const verTutorial = (idTutorial) => {
    cerrar();
    abrir({ tutorialId: idTutorial });
  };

  return (
    <Modal
      open
      title="Novedades"
      onCancel={cerrar}
      width={620}
      destroyOnHidden
      footer={
        <Button type="primary" onClick={cerrar}>
          Entendido
        </Button>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: token.marginLG }}>
        {pendientes.map((p) => (
          <article key={p.id} data-testid="novedad">
            {p.imagen ? (
              <img
                src={urlContenido(base, p.imagen)}
                alt=""
                style={{ width: '100%', borderRadius: token.borderRadiusLG, marginBottom: 12 }}
              />
            ) : null}
            <Tag color="blue">{p.etiqueta ?? 'Nuevo'}</Tag>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {new Date(`${p.fecha}T12:00:00`).toLocaleDateString('es-CL', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
            </Text>
            <Title level={4} style={{ marginTop: 4 }}>
              {p.titulo}
            </Title>
            {p.cuerpo.map((parrafo) => (
              <Paragraph key={parrafo}>{parrafo}</Paragraph>
            ))}
            {p.tutorial ? (
              <Button onClick={() => verTutorial(p.tutorial)}>Ver tutorial</Button>
            ) : null}
          </article>
        ))}
      </div>
    </Modal>
  );
}
